export default __webpack_public_path__ + "static/media/alert-triangle.1eae4c30.svg";